import { useEffect, useRef, useState } from 'react';
import SidePanel from '../../side-panel/side-panel';
import { SidePanelType } from '../../side-panel/types';
import ButtonPseudo from '../../button/button-pseudo';
import InternalTransactionSidepanelRead from './internal-transaction-sidepanel-read';
import SidePanelLoader from '../../side-panel/loader';
import SignaturePopup from '../signature-popup';
import Popup from '../../popup/popup';
import PermissionDenied from '../../permission-denied/permission-denied';
import {
  BaseellaStatus,
  BlacklistData,
  InternalEnumTabs,
  DocumentStatus,
  BlacklistUserInfoData,
} from '../types';
import GeneralLedgerSidepanel from '../general-ledger/general-ledger-sidepanel';
import ButtonSecondary from '../../button/button-secondary';
import InternalTransactionSidepanelContentForm from './internal-transacation-sidepanel-content-form';
import { PermissionEnum } from '../../../base-types';
import DocumentSidePanel from '../documents/document-sidepanel';
import BlacklistDataContent from '../warnings/blacklist-data-content';
import BlacklistUserInfo from '../warnings/blacklist-user-info';
import ButtonPrimary from '../../button/button-primary';
import { InternalSidePanelTypes } from './types';
import usePrevious from '../../../hooks/use-previous';

import styles from '../transaction.module.css';

export default function InternalSidepanel({
  enableEdit,
  isLoading,
  internalError,
  panelIsOpen,
  handleClose,
  title,
  handleSubmit,
  statusesInfo,
  onNextStatus,
  onChangeStatusPopup,
  setStatusPopupVisible,
  statusPopupVisible,
  isCreateForm,
  isDisabledSaveButton,
  createAllowed,
  transactionInfo,
  amlInfo,
  baseellaStatus,
  logs,
  warnings,
  employee,
  onApplyTransactionAction,
  changeLogs,
  checkInProgress,
  signaturePopupVisible,
  sendCode,
  validateCode,
  transactionId,
  validateCodeInProgress,
  signatures,
  errorSidepanel,
  rejectPopupVisible,
  setRejectPopupVisible,
  onReject,
  rejectInProgress,
  updateStatusIsLoading,
  isLoadingStatuses,
  errorMessageSignature,
  transactionsTypes,
  transactionCheckError,
  onSignatureCancelClick,
  activePermission,
  onChangeStatusPopupLoading,
  createdByOrganizationId,
  latestQueuedStatus,
  statusChangeError,
  applyTransactionsWarningIsLoading,
  chats,
  onCreateTransactionChat,
  chatCreateInProgress,
  currentEmployee,
  createChatWithMessage,
  documents,
  document: documentItem,
  documentFileIsLoading,
  downloadInProgress,
  imgLink,
  onDelete,
  deleteInProgress,
  deleteIsSuccess,
  onMove,
  moveInProgress,
  onDownload,
  sendComment,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  commentInProgress,
  changeCustomerDocumentsStatus,
  uploadDocumentErrors,
  uploadDocumentInProgress,
  uploadDocumentIsSuccess,
  onUploadDocument,
  onDownloadSuccess,
  getTransactionDocument,
  documentIsLoading,
  glTransactionsIsLoading,
  glTransactionIsLoading,
  glTransactions,
  onGlTransactionClick,
  glTransaction,
  clearGlTransactionState,
  deleteIsVisible,
  expandedGLTransactionCreditBalance,
  expandedGLTransactionDebitBalance,
  expendedDebitBalanceIsLoading,
  expendedCreditBalanceIsLoading,
  deleteTransactionError,
  onDeleteTransactions,
  deleteTransactionInProgress,
  updateIsLoading,
  createIsLoading,
  canSignTransaction,
  deleteTransactionDisabled,
  sendCodeInProgress,
  currenciesList,
  onDuplicate,
  duplicate,
  getTransactionDocuments,
  documentsIsLoading,
  getGeneralLedgerTransactionValues,
  getTransactionsChats,
  transactionChatsIsLoading,
  getSignaturesTransactionById,
  isLoadingSignatures,
  getInternalTransactionByIdAmlAction,
  isLoadingAml,
  getLogsTransactionById,
  isLoadingLogs,
  recipientCompanyOfficials,
  senderCompanyOfficials,
  documentStatusChangeInProgress,
  isEditable,
  children,
  allCurrenciesList,
  control,
  currencies,
  errors,
  recipientAccounts,
  senderAccounts,
  onSearchAutocomplete,
  recipientAccountsIsLoading,
  senderAccountsIsLoading,
  feeText,
  senderAccountBalance,
  recipientAccountBalance,
  currencyId,
  senderBalanceIsLoading,
  recipientBalanceIsLoading,
  senderBalances,
  recipientBalances,
  amount,
  setAmount,
  overdraftEnabled,
  recipientAccountsWithInfo,
  senderAccountsWithInfo,
  fields,
  checkError,
  isDirty,
  updateSenderBalance,
  updateRecipientBalance,
  sendMessage,
  tabs,
  transactionFee,
  isWarning,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  sidepanelExpandedKey,
  documentsPagination,
  documentsIsFetching,
  transferDate,
  attachedDocumentsErrors,
  uploadedDocumentsErrors,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  getInternalTransactionWarningById,
  isWarningByIdFetching,
  isWarningByIdLoading,
  warningsInfo,
  selectedWarningId,
  warningActionError,
  clearErrors,
  deleteDisabled,
}: InternalSidePanelTypes): React.JSX.Element {
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [deleteTransactionPopupVisible, setDeleteTransactionPopupVisible] =
    useState(false);
  const [activeTab, setActiveTab] = useState<InternalEnumTabs>();
  const [glTransactionSidepanelVisible, setGlTransactionSidePanelVisible] =
    useState(false);
  const [transactionSidePanelVisible, setTransactionSidepanelVisible] =
    useState(panelIsOpen);
  const [blacklistDataVisible, setBlacklistDataVisible] = useState(false);
  const [blacklistData, setBlacklistData] = useState<BlacklistData>();
  const [subPanelVisible, setSubPanelVisible] = useState(false);
  const [selectedDocumentName, setSelectedDocumentName] = useState('');
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    DocumentStatus | undefined
  >(undefined);
  const [blacklistItem, setBlacklistDataItem] =
    useState<BlacklistUserInfoData>();
  const [blacklistItemVisible, setBlacklistItemVisible] = useState(false);
  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);

  const prevEditInProgress = usePrevious(updateIsLoading);

  const tabsItems = isCreateForm
    ? [{ name: 'General Info', value: InternalEnumTabs.GENERAL }]
    : [
        { name: 'General Info', value: InternalEnumTabs.GENERAL },
        { name: 'Warning', value: InternalEnumTabs.WARNING },
        { name: 'AML & KYC', value: InternalEnumTabs.AML },
        { name: 'Status log', value: InternalEnumTabs.LOG },
        { name: 'Change Log', value: InternalEnumTabs.CHANGE_LOG },
        { name: 'Signatures', value: InternalEnumTabs.SIGNATURES },
        { name: 'Documents', value: InternalEnumTabs.DOCUMENTS },
        { name: 'Accounting entries', value: InternalEnumTabs.GL_TRANSACTIONS },
        { name: 'Chats', value: InternalEnumTabs.CHATS },
        { name: 'Comments', value: InternalEnumTabs.COMMENTS },
      ];

  const handleScroll = () => {
    setScroll((prev) => {
      if (prev !== Number(scrollRef.current?.scrollTop)) {
        return Number(scrollRef.current?.scrollTop);
      }
      return prev;
    });
  };

  const handleCloseBlacklistData = () => {
    setBlacklistDataVisible(false);
    setBlacklistData(undefined);
    setBlacklistItemVisible(false);
    setBlacklistDataItem(undefined);
    setTransactionSidepanelVisible(true);
  };

  useEffect(() => {
    setTransactionSidepanelVisible(panelIsOpen);
  }, [panelIsOpen]);

  useEffect(() => {
    if (onDownloadSuccess && selectedDocumentId && !downloadInProgress) {
      setSelectedDocumentId('');
    }
  }, [onDownloadSuccess, selectedDocumentId, downloadInProgress]);

  useEffect(() => {
    if (deleteIsSuccess) {
      setDeletePopupVisible(false);
      setSubPanelVisible(false);
      setTransactionSidepanelVisible(true);
      setActiveTab(InternalEnumTabs.DOCUMENTS);
    }
  }, [deleteIsSuccess]);

  useEffect(() => {
    const element = scrollRef.current;

    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!updateIsLoading && prevEditInProgress) {
      setConfirmationPopupVisible(false);
    }
  }, [updateIsLoading, prevEditInProgress]);

  let content;
  let contentError;

  if (checkError) {
    contentError = checkError;
  } else if (errors) {
    contentError = 'There are errors in some fields';
  } else if (errorSidepanel) {
    contentError = errorSidepanel;
  }

  if (isLoading && !internalError) {
    content = <SidePanelLoader />;
  } else if (enableEdit && !internalError) {
    if ((isCreateForm && createAllowed) || transactionId) {
      content = (
        <InternalTransactionSidepanelContentForm
          tabs={tabsItems}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          warnings={warnings}
          duplicate={duplicate}
          getTransactionDocuments={getTransactionDocuments}
          getGeneralLedgerTransactionValues={getGeneralLedgerTransactionValues}
          getTransactionsChats={getTransactionsChats}
          activePermission={activePermission}
          transactionInfo={transactionInfo}
          getSignaturesTransactionById={getSignaturesTransactionById}
          getInternalTransactionByIdAml={getInternalTransactionByIdAmlAction}
          getLogsTransactionById={getLogsTransactionById}
          baseellaStatus={baseellaStatus}
          canSignTransaction={canSignTransaction}
          createdByOrganizationId={createdByOrganizationId}
          sendCodeInProgress={sendCodeInProgress}
          sendCode={sendCode}
          setRejectPopupVisible={setRejectPopupVisible}
          statusesInfo={statusesInfo}
          onNextStatus={onNextStatus}
          updateStatusIsLoading={updateStatusIsLoading}
          isLoadingStatuses={isLoadingStatuses}
          latestQueuedStatus={latestQueuedStatus}
          parentScroll={scroll}
          parentRef={scrollRef}
          isCreateForm={!transactionInfo}
          employee={employee}
          onApplyTransactionAction={onApplyTransactionAction}
          transactionsTypes={transactionsTypes}
          setBlacklistDataVisible={(visible) => {
            setBlacklistDataVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistItemVisible={(visible) => {
            setBlacklistItemVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistData={setBlacklistData}
          setBlacklistDataItem={setBlacklistDataItem}
          applyTransactionsWarningIsLoading={applyTransactionsWarningIsLoading}
          chats={chats}
          createChatWithMessage={createChatWithMessage}
          chatCreateInProgress={chatCreateInProgress}
          amlInfo={amlInfo}
          isLoadingAml={isLoadingAml}
          recipientCompanyOfficials={recipientCompanyOfficials}
          senderCompanyOfficials={senderCompanyOfficials}
          isLoadingLogs={isLoadingLogs}
          logs={logs}
          changeLogs={changeLogs}
          documents={documents}
          setSubPanelVisible={setSubPanelVisible}
          setSelectedDocumentName={setSelectedDocumentName}
          setTransactionSidepanelVisible={setTransactionSidepanelVisible}
          onUploadDocument={onUploadDocument}
          uploadDocumentInProgress={uploadDocumentInProgress}
          uploadDocumentIsSuccess={uploadDocumentIsSuccess}
          uploadDocumentErrors={uploadDocumentErrors}
          selectedDocumentId={selectedDocumentId}
          setSelectedDocumentId={setSelectedDocumentId}
          downloadInProgress={documentFileIsLoading || downloadInProgress}
          onDownloadDocument={onDownload}
          getTransactionDocument={getTransactionDocument}
          documentsIsLoading={documentsIsLoading}
          signatures={signatures}
          isLoadingSignatures={isLoadingSignatures}
          glTransactionsIsLoading={glTransactionsIsLoading}
          glTransactions={glTransactions}
          setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
          onGlTransactionClick={onGlTransactionClick}
          currenciesList={currenciesList}
          availableCurrencies={currencies}
          onCreateTransactionChat={onCreateTransactionChat}
          currentEmployee={currentEmployee}
          transactionChatsIsLoading={transactionChatsIsLoading}
          control={control}
          errors={errors}
          isEditable={isEditable}
          senderAccounts={senderAccounts}
          recipientAccounts={recipientAccounts}
          senderAccountsIsLoading={senderAccountsIsLoading}
          recipientAccountsIsLoading={recipientAccountsIsLoading}
          onSearchAutocomplete={onSearchAutocomplete}
          fields={fields}
          senderAccountBalance={senderAccountBalance}
          recipientAccountBalance={recipientAccountBalance}
          currencyId={currencyId}
          senderAccountBalances={senderBalances}
          recipientAccountBalances={recipientBalances}
          senderAccountBalancesIsLoading={senderBalanceIsLoading}
          recipientAccountBalancesIsLoading={recipientBalanceIsLoading}
          overdraftEnabled={overdraftEnabled}
          recipientAccountsWithInfo={recipientAccountsWithInfo}
          senderAccountsWithInfo={senderAccountsWithInfo}
          amount={amount}
          setAmount={setAmount}
          allCurrenciesList={allCurrenciesList}
          feeText={feeText}
          updateSenderBalance={updateSenderBalance}
          updateRecipientBalance={updateRecipientBalance}
          getTransactionChangeLogs={getTransactionChangeLogs}
          changeLogsIsLoading={changeLogsIsLoading}
          users={users}
          transactionChangeLogsPagination={transactionChangeLogsPagination}
          changeLogsIsFetching={changeLogsIsFetching}
          transactionId={transactionId}
          onResetTransactionWarningAction={onResetTransactionWarningAction}
          resetTransactionsWarningIsLoading={resetTransactionsWarningIsLoading}
          resetTransactionsWarningIsSuccess={resetTransactionsWarningIsSuccess}
          documentsPagination={documentsPagination}
          documentsIsFetching={documentsIsFetching}
          transferDate={transferDate}
          attachedDocumentsErrors={attachedDocumentsErrors}
          uploadedDocumentsErrors={uploadedDocumentsErrors}
          transactionComments={transactionComments}
          transactionCommentsPagination={transactionCommentsPagination}
          getTransactionCommentsAction={getTransactionCommentsAction}
          commentsIsLoading={commentsIsLoading}
          commentsIsFetching={commentsIsFetching}
          onAddCommentToTransaction={onAddCommentToTransaction}
          addCommentInProgress={addCommentInProgress}
          addCommentIsSuccess={addCommentIsSuccess}
          onEditCommentInTransaction={onEditCommentInTransaction}
          editTransactionCommentInProgress={editTransactionCommentInProgress}
          editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
          onDeleteCommentInTransaction={onDeleteCommentInTransaction}
          deleteCommentInTransactionInProgress={
            deleteCommentInTransactionInProgress
          }
          deleteCommentInTranscationIsSuccess={
            deleteCommentInTranscationIsSuccess
          }
          getInternalTransactionWarningById={getInternalTransactionWarningById}
          isWarningByIdFetching={isWarningByIdFetching}
          isWarningByIdLoading={isWarningByIdLoading}
          warningsInfo={warningsInfo}
          selectedWarningId={selectedWarningId}
          warningActionError={warningActionError}
          clearErrors={clearErrors}
        />
      );
    } else if (!createAllowed && isCreateForm) {
      content = <PermissionDenied />;
    }
  } else if (internalError) {
    content = <div className={styles.internalError}>{internalError}</div>;
  } else {
    content = (
      <InternalTransactionSidepanelRead
        tabs={tabs}
        parentRef={scrollRef}
        parentScroll={scroll}
        sendMessage={sendMessage}
        warningsCount={warnings?.filter((item) => !item.action)?.length}
        setSubPanelVisible={setSubPanelVisible}
        setSelectedDocumentName={setSelectedDocumentName}
        setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
        onGlTransactionClick={onGlTransactionClick}
        deletedAt={transactionInfo?.deletedAt}
        getTransactionDocument={getTransactionDocument}
        isWarning={isWarning}
        transactionFee={transactionFee}
      />
    );
  }

  let footerButton;

  if (baseellaStatus !== BaseellaStatus.NOT_SIGNED && enableEdit) {
    if (transactionId && isEditable) {
      footerButton = (
        <ButtonPrimary
          text="Save"
          disabled={isDisabledSaveButton}
          onClick={() => setConfirmationPopupVisible(true)}
          bold
        />
      );
    } else if (isCreateForm && createAllowed) {
      footerButton = (
        <ButtonPrimary
          text={createIsLoading ? 'Loading...' : 'Save'}
          disabled={isDisabledSaveButton}
          onClick={sendCode}
          bold
        />
      );
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={transactionSidePanelVisible}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={title}
        errorSidepanel={contentError || statusChangeError}
        checkInProgress={checkInProgress}
        transactionCheckError={transactionCheckError}
        checkText="Checking transaction..."
        sidepanelExpandedKey={sidepanelExpandedKey}
        footer={
          <>
            {!internalError && footerButton}
            {!isLoading && (
              <>
                {transactionId && onDuplicate && (
                  <ButtonSecondary
                    text="Duplicate"
                    onClick={onDuplicate}
                    className={styles.duplicateButton}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      deleteTransactionInProgress ||
                      updateIsLoading,
                    )}
                    bold
                  />
                )}
                {!internalError && transactionId && !deleteDisabled && (
                  <ButtonSecondary
                    text={
                      deleteTransactionInProgress
                        ? 'Loading...'
                        : 'Delete transaction'
                    }
                    className={`button-white button-warning ${styles.deleteTransactionButton}`}
                    disabled={
                      deleteTransactionInProgress ||
                      deleteTransactionDisabled ||
                      updateStatusIsLoading ||
                      deleteTransactionInProgress ||
                      updateIsLoading
                    }
                    onClick={() => setDeleteTransactionPopupVisible(true)}
                    bold
                  />
                )}
              </>
            )}

            <ButtonPseudo text="Cancel" onClick={handleClose} bold />
          </>
        }
        className={styles.transactionSidepanel}
        childrenRef={scrollRef}
      >
        <>
          {children}
          {content}
        </>
      </SidePanel>
      <GeneralLedgerSidepanel
        panelIsOpen={glTransactionSidepanelVisible}
        handleClose={() => {
          if (clearGlTransactionState) {
            clearGlTransactionState();
          }
          setTransactionSidepanelVisible(true);

          setGlTransactionSidePanelVisible(false);
          setActiveTab(InternalEnumTabs.GL_TRANSACTIONS);
        }}
        transaction={glTransaction}
        isLoading={glTransactionIsLoading as boolean}
        title="GL Transaction"
        debitAccountBalance={expandedGLTransactionDebitBalance}
        creditAccountBalance={expandedGLTransactionCreditBalance}
        debitBalanceIsLoading={expendedDebitBalanceIsLoading}
        creditBalanceIsLoading={expendedCreditBalanceIsLoading}
        sidepanelExpandedKey="internal-gl-transaction"
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={subPanelVisible}
        onClose={() => {
          setSubPanelVisible(false);
          setSelectedDocumentName('');
          setTransactionSidepanelVisible(true);
          setActiveTab(InternalEnumTabs.DOCUMENTS);
        }}
        title={selectedDocumentName}
        sidepanelExpandedKey="internal-documents-sidepanel"
        footer={
          <>
            {((documentItem?.organizationId ===
              transactionInfo?.recipientAccount?.organization.id &&
              transactionInfo?.recipientAccount?.organization?.type ===
                'INDIVIDUAL' &&
              activePermission?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
              )) ||
              (documentItem?.organizationId ===
                transactionInfo?.recipientAccount?.organization.id &&
                transactionInfo?.recipientAccount?.organization?.type ===
                  'CORPORATE' &&
                activePermission?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                )) ||
              (documentItem?.organizationId ===
                transactionInfo?.senderAccount?.organization.id &&
                transactionInfo?.senderAccount?.organization?.type ===
                  'INDIVIDUAL' &&
                activePermission?.includes(
                  PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                )) ||
              (documentItem?.organizationId ===
                transactionInfo?.senderAccount?.organization.id &&
                transactionInfo?.senderAccount?.organization?.type ===
                  'CORPORATE' &&
                activePermission?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                ))) &&
              documentItem && (
                <>
                  {documentItem.status !== DocumentStatus.ACCEPTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          documentStatusChangeInProgress &&
                          selectedStatus === DocumentStatus.ACCEPTED
                            ? 'Loading...'
                            : 'Accept'
                        }
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.ACCEPTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.ACCEPTED,
                            });
                          }
                        }}
                        disabled={
                          documentStatusChangeInProgress || documentIsLoading
                        }
                        bold
                      />
                    )}
                  {documentItem.status !== DocumentStatus.REJECTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          documentStatusChangeInProgress &&
                          selectedStatus === DocumentStatus.REJECTED
                            ? 'Loading...'
                            : 'Reject'
                        }
                        className={styles.rejectStatusButton}
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.REJECTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.REJECTED,
                            });
                          }
                        }}
                        disabled={
                          documentStatusChangeInProgress || documentIsLoading
                        }
                        bold
                      />
                    )}
                </>
              )}
            <ButtonPseudo
              text="Close"
              onClick={handleClose}
              className="button-white"
              bold
            />
          </>
        }
      >
        {documentIsLoading ? (
          <SidePanelLoader />
        ) : (
          <DocumentSidePanel
            document={documentItem}
            documentFileIsLoading={documentFileIsLoading}
            downloadInProgress={downloadInProgress}
            imgLink={imgLink}
            setDeletePopupVisible={setDeletePopupVisible}
            onMove={onMove}
            moveInProgress={moveInProgress}
            onDownload={onDownload}
            deleteIsVisible={deleteIsVisible}
            customerType={transactionInfo?.recipientAccount?.organization?.type}
            commentsVisible={activePermission?.includes(
              PermissionEnum.DOCUMENTS_COMMENTS_ACTION,
            )}
            sendComment={sendComment}
            editComment={editComment}
            editCommentInProgress={editCommentInProgress}
            editCommentIsSuccess={editCommentIsSuccess}
            deleteComment={deleteComment}
            deleteCommentInProgress={deleteCommentInProgress}
            commentInProgress={commentInProgress}
            activePermissions={activePermission}
            onDownloadSuccess={onDownloadSuccess}
          />
        )}
      </SidePanel>
      <Popup
        title="Delete transaction?"
        onCancelClick={() => setDeleteTransactionPopupVisible(false)}
        onOkClick={() =>
          onDeleteTransactions && onDeleteTransactions(transactionId as string)
        }
        cancelButtonText="Cancel"
        okButtonText={deleteTransactionInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteTransactionPopupVisible}
        isLoading={deleteTransactionInProgress}
        parent={document.getElementById('signature-popup') as HTMLElement}
      >
        <div>
          {deleteTransactionError && (
            <div className={styles.transactionDeleteError}>
              {deleteTransactionError}
            </div>
          )}
        </div>
      </Popup>
      <Popup
        title={`Delete ${documentItem?.name}`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={() => onDelete && onDelete(documentItem?.id as string)}
        cancelButtonText="Cancel"
        okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
        isVisible={deletePopupVisible}
        isLoading={deleteInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <Popup
        title="You have unsaved changed"
        description="You want to change the status of a transaction, but you have unsaved changes on the transaction. Please select one of the following options:"
        onCancelClick={() =>
          setStatusPopupVisible && setStatusPopupVisible(false)
        }
        onOkClick={onChangeStatusPopup}
        isLoading={onChangeStatusPopupLoading}
        cancelButtonText="Cancel"
        okButtonText="Save changes and change status"
        isVisible={Boolean(statusPopupVisible)}
        parent={document.getElementById('status-popup') as HTMLElement}
      />
      <SignaturePopup
        signaturePopupVisible={signaturePopupVisible}
        validateCode={validateCode}
        validateCodeInProgress={validateCodeInProgress}
        errorMessageSignature={errorMessageSignature}
        onSignatureCancelClick={onSignatureCancelClick}
      />
      <Popup
        title="The transaction will be rejected"
        onCancelClick={() =>
          setRejectPopupVisible && setRejectPopupVisible(false)
        }
        onOkClick={onReject}
        cancelButtonText="Cancel"
        okButtonText="Yes, Reject"
        isVisible={rejectPopupVisible as boolean}
        parent={document.getElementById('signature-popup') as HTMLElement}
        isLoading={rejectInProgress}
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistDataVisible}
        onClose={handleCloseBlacklistData}
        title={blacklistData?.fullName as string}
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="internal-blacklist-data"
      >
        <BlacklistDataContent data={blacklistData} />
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistItemVisible}
        onClose={handleCloseBlacklistData}
        title="User Details"
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="internal-blacklist-data"
        withoutExpand
        expanded
      >
        <BlacklistUserInfo info={blacklistItem} isLoading={false} />
      </SidePanel>
      <Popup
        title="Are you sure to save all changes?"
        onCancelClick={() => setConfirmationPopupVisible(false)}
        onOkClick={handleSubmit}
        isLoading={updateIsLoading}
        cancelButtonText="Cancel"
        okButtonText={updateIsLoading ? 'Loading...' : 'Save changes'}
        isVisible={confirmationPopupVisible}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={updateIsLoading}
      />
      <div id="status-popup" />
      <div id="dirty-popup" />
      <div id="signature-popup" />
      <div id="blacklist-data-sidepanel" />
      <div id="delete-popup-wrapper" />
    </>
  );
}
